import { useContext } from "react";
import { DetailHeader } from "../../components/detailHeader/DetailHeader";
import { RecordContext } from "../../components/record/Record";

export const GapPriorityDetailHeader = () => {
    const recordContext = useContext(RecordContext);

    if (!recordContext) return null;

    return <DetailHeader collection={recordContext.collection} deleteOnUpdate={{ forceRoute: "gaps" }} />;
};
